var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDangerous = function SvgDangerous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.462 20.5 3.5 15.539V8.46L8.461 3.5h7.078L20.5 8.461v7.078L15.539 20.5zm.688-4.596 2.85-2.85 2.85 2.85 1.054-1.054-2.85-2.85 2.85-2.85-1.054-1.054-2.85 2.85-2.85-2.85L8.096 9.15l2.85 2.85-2.85 2.85zM9.1 19h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8z"
  })));
};
export default SvgDangerous;